import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CustomerCreateComponent } from "@modules/customer/create/create.component";
import { CustomerSearchComponent } from "@modules/customer/customer-search/customer-search.component";
import { PlaceHolderComponent } from "@core/placeholder.component";
import { AuthGuard, PublicGuard } from "../common/auth.guard";
import { CertificateComponent } from "./certificate/certificate.component";
import { CodComponent } from "./cod/cod.component";
import { ConfirmDetailsComponent } from "./confirm-details/confirm-details.component";
import { CreateComponent } from "./create/create.component";
import { DetailsComponent } from "./details/details.component";
import { InvoicePrintComponent } from "./invoice-print/invoice-print.component";
import { InvoiceComponent } from "./invoice/invoice.component";
import { JobMachinePrintComponent } from "./job-machine-print/job-machine-print.component";
import { LineListComponent } from "./line-list/line-list.component";
import { ListLiteComponent } from "./list-lite/list-lite.component";
import { ListComponent } from "./list/list.component";
import { PrintComponent } from "./print/print.component";
import { ReceiptComponent } from "./receipt/receipt.component";
import { SearchComponent } from "./search/search.component";
import { SummaryComponent } from "./summary/summary.component";
import { JobValidationComponent } from "./validation/validation.component";
import { ExchangeListComponent } from "./exchange/exchange-list.component";

const routes: Routes = [
  {
    path: "public",
    canActivate: [PublicGuard],
    children: [
      {
        path: "",
        component: SearchComponent,
        data: { title: "Jobs", narrow: true, isPublic: true }
      },
      {
        path: "pay/:jobId/:check",
        component: CodComponent,
        data: { title: "Job", isPublic: true }
      },
      {
        path: "rate/:jobId/:check",
        component: JobValidationComponent,
        data: { title: "Job", isPublic: true }
      },
      {
        path: "create",
        component: CreateComponent,
        data: { title: "New Job", narrow: true, isPublic: true }
      },
      {
        path: "fbcreate",
        component: ConfirmDetailsComponent,
        data: { title: "New Donation", narrow: true, isPublic: true }
      },
      {
        path: "fbcreate/:jobId/:check",
        component: ConfirmDetailsComponent,
        data: { title: "Job", narrow: true, isPublic: true }
      },
      {
        path: "fbcreate/:jobId/:check/invoice/:invoice",
        component: CertificateComponent,
        data: { title: "Certificate", narrow: true, isPublic: true }
      },

      // For General Product Registration
      {
        path: "register",
        component: CustomerCreateComponent,
        data: { title: "New Product Registration", narrow: true, isPublic: true }
      },
      {
        path: "search",
        component: CustomerSearchComponent,
        data: { title: "Customer Search", narrow: true, isPublic: true }
      },
      {
        path: "search/register",
        redirectTo: 'register'
      },
      {
        path: "search/create",
        redirectTo: 'create'
      },
      // End General Registration Routes

      // Use these Routes for Prod Reg. Campaigns
      // For Parameterised Products Registration (Campaigns)
      {
        path: "product-registration-extended",
        component: CustomerCreateComponent,
        data: { title: "Product Registration", narrow: true, isPublic: true, filterModelsBy: 'extended' }
        // this effectively passes a parameter to the Model lookup to filter for Campaign filter option
      },
      {
        path: "product-registration",
        component: CustomerSearchComponent,
        data: { title: "Product Registration", narrow: true, isPublic: true, registerRoute: 'product-registration-extended' }
      },
      {
        path: "product-registration/product-registration-extended",
        redirectTo: 'product-registration-extended'
      },
      // end Campaigns

      {
        path: ":jobId",
        component: ConfirmDetailsComponent,
        data: { title: "Job", narrow: true, isPublic: true }
      },
      {
        path: ":jobId/:check",
        component: ConfirmDetailsComponent,
        data: { title: "Jobs", narrow: true, isPublic: true }
      },
      {
        path: ":jobId/:check/print",
        component: PrintComponent,
        data: { title: "Job Card", narrow: true, isPublic: true }
      },
      {
        path: ":jobId/:check/receipt/:receipt",
        component: ReceiptComponent,
        data: { title: "Receipt", narrow: true, isPublic: true }
      },
      {
        path: ":jobId/:check/invoice/:invoice",
        component: InvoiceComponent,
        data: { title: "Invoice", narrow: true, isPublic: true }
      },
      {
        path: ":jobId/:check/certificate/:invoice",
        component: CertificateComponent,
        data: { title: "Certificate", narrow: true, isPublic: true }
      },
    ]
  },
  {
    path: "",
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        component: SearchComponent,
        data: { title: "Jobs", narrow: true }
      },
      {
        path: "list",
        component: ListComponent,
        data: { title: "Jobs", wide: true }
      },
      {
        path: "list/line",
        component: LineListComponent,
        data: { title: "Jobs", wide: true }
      },
      {
        path: "listlite",
        component: ListLiteComponent,
        data: { title: "Jobs" }
      },

      {
        path: "summary/:mode",
        redirectTo: "summary"
      },

      {
        path: "summary", // :mode
        component: SummaryComponent,
        data: { title: "Open Jobs", narrow: true }
      },
      {
        path: "create",
        component: CreateComponent,
        data: { title: "New Job", narrow: true }
      },
      {
        path: "exchange",
        component: ExchangeListComponent,
        data: { title: "Exchange", narrow: false }
      },
      {
        path: ":jobId/cod",
        component: CodComponent,
        data: { title: "Job Payment", narrow: true }
      },
      {
        path: ":jobId",
        component: DetailsComponent,
        data: { title: "Job", narrow: true }
      },
      {
        path: ":jobId/receipt/:receipt",
        component: ReceiptComponent,
        data: { title: "Receipt", narrow: true }
      },
      {
        path: ":jobId/invoice/:invoice",
        component: InvoiceComponent,
        data: { title: "Invoice", narrow: true }
      },
      {
        path: ":jobId/deliverynote/:deliverynote",
        component: JobMachinePrintComponent,
        data: { title: "Delivery Note", narrow: true }
      },
      {
        path: "invoice/:invoice",
        component: InvoicePrintComponent,
        data: { title: "Invoice", narrow: true }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobRoutingModule {}
